// extracted by mini-css-extract-plugin
module.exports = {"__graph-line-color":"#e9b342","__graph-border-color":"#768083","__graph-font-color":"#000"};